import getValidationMessage from '@/helpers/getValidationMessage';
import userAgentMixin from '@/mixins/userAgent';

export default {
  mixins: [userAgentMixin],
  props: {
    type: {
      type: String,
      default: 'text',
    },
    autocomplete: {
      type: String,
      required: false,
    },
    disabled: Boolean,
    name: {
      type: String,
      required: true,
    },
    required: Boolean,
    placeholder: String,
    maxLength: Number,
    max: Number,
    min: Number,
    value: [String, Number],
    // new stuff
    validation: Object,
    theme: {
      type: String,
      default: '',
    },
    tabindex: Number,
    gtm: {
      type: String,
      default: '',
    },
    hideIconOnValue: {
      type: Boolean,
      default: true,
    },
    showValidationWithin: {
      type: Boolean,
      default: true,
    },
    masked: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      focus: false,
    };
  },
  computed: {
    inputStyleModifiers() {
      if (this.masked) {
        return {
          'text-security': 'disc',
          '-webkit-text-security': 'disc',
          '-moz-text-security': 'disc',
        };
      }
      return {};
    },
    inputModifiers() {
      return {
        'input--no-placeholder': !this.placeholder,
        'input--has-value': this.value,
        'input--is-focused': this.focus,
        'input--is-disabled': this.disabled,
        'input--hide-icon': this.hideIconOnValue,
        [`input--${this.theme}`]: this.theme,
      };
    },
    errorMessage() {
      return this.validation ? getValidationMessage(this.validation) : '';
    },
    error() {
      return this.validation ? this.validation.$error : false;
    },
    successTick() {
      // if (this.validation) {
      //   if (this.validation.required === undefined && this.value === '') {
      //     return false;
      //   }
      //   return this.validation.$dirty && !this.validation.$invalid;
      // }
      return false;
    },
    hasIcon() {
      return !!this.$slots.icon;
    },
    gtmObject() {
      const [category, label] = this.gtm.split(',');
      return {
        event: 'eventTrackerTrigger',
        category,
        action: 'fill',
        label,
      };
    },
  },
  methods: {
    handleBlur(e) {
      this.focus = false;
      this.$emit('blur', e.target.name);
      if (this.gtm && this.value) {
        this.$gtm.trackEvent(this.gtmObject);
      }
    },
    handleFocus(e) {
      this.focus = true;
      this.$emit('focus', e.target.name);

      if (this.isWrapperApp) {
        e.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    },
    updateValue(e) {
      this.$emit('input', e.target.value);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/forms/input/input.js